import { averages } from './changeRates'
import { average } from './utility'

export const HOMES_BUILT_K12_RATE = 0.7
export const HOMES_BUILT_K8_RATE = 0.5
export const HOMES_BUILT_912_RATE = 0.2

export function handleHomesBuilt(homes, years, grades) {
    const additional = [...Array(years)].map(() => Array(grades).fill(0))

    if (homes) {
        let rate

        if (grades < 5) {
            rate = HOMES_BUILT_912_RATE
        } else if (grades < 10) {
            rate = HOMES_BUILT_K8_RATE
        } else {
            rate = HOMES_BUILT_K12_RATE
        }

        const total = Math.round(homes * rate)
        const perYear = Math.round(total / years)
        const yearExtra = total % years

        for (let i = 0, il = years; i < il; i += 1) {
            const perThisYear = (i < yearExtra) ? perYear + 1 : perYear
            const perGrade = Math.round(perThisYear / grades)
            const gradeExtra = perThisYear % grades

            for (let x = 0, xl = grades; x < xl; x += 1) {
                additional[i][x] = (x < gradeExtra) ? perGrade + 1 : perGrade
            }
        }
    }

    return additional
}

export function project(years, count, homes, filters) {
    // Get change rates for each grade per year
    const changeAverages = averages(years, filters)
    const gradeCount = changeAverages.length + 1
    const initialGradeAverage = Math.round(average(years.map((i) => i.enrollments[0])))

    // Number of homes built distributes students across all grade levels
    const additional = handleHomesBuilt(homes, count, gradeCount)

    for (let i = 0; i < count; i += 1) {
        const prev = years[years.length - 1]
        const firstPartOfYear = parseInt(prev.year.split('-')[0], 10) + 1
        const year = `${firstPartOfYear}-${(firstPartOfYear + 1).toString().slice(2)}`
        const prevEnrollments = prev.enrollments

        const enrollments = [initialGradeAverage, ...changeAverages].map((rate, x) => {
            const add = additional[i][x]

            if (x === 0) {
                // `rate` is an integer for the initial grade
                return rate + add
            }

            return Math.round(prevEnrollments[x - 1] * (1 + rate)) + add
        })

        years.push({
            year,
            enrollments,
            projection: true,
        })
    }

    return years
}
